import styled from 'styled-components';
import { Col, Layout, Row, Checkbox } from 'antd';

export const Wrapper = styled(Layout)`
  height: 100%;
  padding: 13px 27px 6px 27px;
  overflow-x: hidden;

  .ant-input {
    background: #f2f2f2;
  }

  .painel-listas {
    margin-top: 24px;
  }

  .painel-list-card {
    height: 100%;
    border-top: 3px solid #24a95d;
  }

  .painel-list-card > .ant-card-head {
    min-height: 44px;
  }

  .painel-list-card > .ant-card-body {
    padding: 16px;
  }

  .painel-list-content {
    min-height: 440px;
  }

  .painel-list-search {
    height: 42px;
    margin-bottom: 12px;
    border: none;
  }

  .painel-list-content .ant-table-cell {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    vertical-align: middle;
  }

  .painel-list-content .ant-table-tbody > tr:nth-child(odd) > td {
    background: #f7f7f7;
  }

  .painel-list-content .ant-btn-text:not(:disabled) {
    color: #24a95d;
  }

  @media (max-width: 768px) {
    padding: 8px;

    .painel-list-content {
      min-height: 360px;
    }
  }
  .ant-tabs {
    position: relative;
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      .ant-tabs-tab-btn {
        color: #fff;
      }
    }
  }

  th.ant-table-cell {
    background: #fff;
    border-bottom: 2px solid #cacaca;
    text-align: center;
  }
  tr.ant-table-expanded-row td {
    background: #f2f2f2;
  }

  div::-webkit-scrollbar {
    width: 8px;
  }
  div::-webkit-scrollbar-track {
    background: #f4f4f4;
    margin: 145px 0 5px 0;
    border-radius: 20px;
  }
  div::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
  .ant-tabs.ant-tabs-top.ant-tabs-card {
    top: -28px;
  }
  .ant-tabs-tabpane.ant-tabs-tabpane-active {
    height: 565px;
    overflow-y: scroll;
    padding: 28px 20px;
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      .ant-tabs-tab-btn {
        color: #fff;
      }
    }
  }
  .ant-checkbox-inner {
    border-radius: 50%;
    border: 1px solid #24a95d;
    ::after {
      background-color: #24a95d;
      border-color: #24a95d;
    }
  }
  .ant-checkbox-checked::after {
    border-radius: 50%;
    border: 1px solid #24a95d;
    border-color: #24a95d;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #24a95d;
    border-color: #24a95d;
  }
`;

export const Text = styled.p`
  margin: 0;
  color: #707070;
  > span {
    font-weight: bold;
  }
`;

export const Dropdown = styled.div`
  #dropdown {
    border: 1px solid black;
    width: 100%;
    height: 200px;
    opacity: 0;
    display: none;
    animation: dropdown 1s ease-in-out;
  }
  #dropdown-active {
    border: 1px solid black;
    width: 100%;
    height: 0;
    opacity: 0;
    display: block;
  }
  @keyframes dropdown {
    to {
      height: 200px;
      opacity: 1;
    }
  }
`;

export const RowTitle = styled(Col)`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 22px;
  color: #001f2a;
  padding: 12px 0;
  border-bottom: 2px solid #cacaca;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
`;

export const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #707070;
  font-weight: normal;
  text-align: center;
`;

export const StyledColTitle = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #001f2a;
  white-space: nowrap;
`;

export const RowData = styled(Row)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #001f2a;
  min-height: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
export const P = styled.p`
  > span {
    font-weight: bold;
  }
  > pre {
    span {
      font-weight: bold;
    }
  }
`;

export const RowsForColumn = styled.div`
  > .ant-modal {
    width: 60%;
  }
  :nth-child(odd) {
    background: #f2f2f2;
  }
  #dropdown {
    max-height: 0;
    overflow: hidden;
    transition: max-height 300ms ease-in-out;
    background-color: #f2f2f2;
  }
  #dropdown.active {
    max-height: 70px;
    height: 70px;
    transition: max-height 300ms ease-in-out;
  }
  .dropImg {
    transform: rotate(0deg);
    transition: transform 300ms ease-in-out;
    cursor: pointer;
  }
  .dropImg.active {
    transform: rotate(180deg);
    transition: transform 300ms ease-in-out;
    cursor: pointer;
  }
`;

export const RowDrop = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: space-around;

  height: 70px;
  background-color: #f2f2f2;
  border-radius: 2px;
`;

export const ColDrop = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;

  > label {
    font-weight: bold;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    color: #001f2a;
  }
  > p {
    font-size: 12px;
    line-height: 22px;

    text-align: center;

    color: #707070;
  }
`;

export const Fundo = styled.div`
  padding-right: 10px;
  border-radius: 4px;
  background: #fff;
  min-width: 120px;
  margin-top: 40px;
  margin-right: ${props => props.marginRight || 0}px;
  margin-left: ${props => props.marginLeft || 0}px;
`;

export const CheckboxCustom = styled(Checkbox)``;
